import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { ComisionSucursalSchema, PromotorSchema, PromotoresPaginadosSchema, } from '@/data/dto/promotor';
function limpiar(values) {
    const out = {};
    for (const [k, v] of Object.entries(values)) {
        if (v === '' || v === undefined) {
            out[k] = null;
        }
        else if (k === 'pctOverrideEfectivo' || k === 'pctOverrideTarjeta') {
            out[k] = Number(v);
        }
        else {
            out[k] = v;
        }
    }
    return out;
}
function limpiarComision(values) {
    const hereda = values.modo === '';
    return {
        modo: hereda ? null : values.modo,
        pctUnico: !hereda && values.modo === 'UNICO' && values.pctUnico ? Number(values.pctUnico) : null,
        pctEfectivo: !hereda && values.modo === 'POR_METODO_PAGO' && values.pctEfectivo
            ? Number(values.pctEfectivo)
            : null,
        pctTarjeta: !hereda && values.modo === 'POR_METODO_PAGO' && values.pctTarjeta
            ? Number(values.pctTarjeta)
            : null,
    };
}
export const promotoresApi = {
    async listar(filtros) {
        const res = await apiClient.get(ENDPOINTS.promotores, {
            params: {
                q: filtros.q || undefined,
                activo: filtros.activo,
                esEmpleado: filtros.esEmpleado,
                pagina: filtros.pagina,
                porPagina: filtros.porPagina,
            },
        });
        return PromotoresPaginadosSchema.parse(res.data);
    },
    async ver(id) {
        const res = await apiClient.get(`${ENDPOINTS.promotores}/${id}`);
        return PromotorSchema.parse(res.data);
    },
    async crear(values) {
        const res = await apiClient.post(ENDPOINTS.promotores, limpiar(values));
        return PromotorSchema.parse(res.data);
    },
    async editar(id, values) {
        const res = await apiClient.patch(`${ENDPOINTS.promotores}/${id}`, limpiar(values));
        return PromotorSchema.parse(res.data);
    },
    async desactivar(id) {
        await apiClient.delete(`${ENDPOINTS.promotores}/${id}`);
    },
    async verComisionSucursal(sucursalId) {
        const res = await apiClient.get(`${ENDPOINTS.sucursales}/${sucursalId}/comisiones`);
        return ComisionSucursalSchema.parse(res.data);
    },
    async upsertComisionSucursal(sucursalId, values) {
        const res = await apiClient.patch(`${ENDPOINTS.sucursales}/${sucursalId}/comisiones`, limpiarComision(values));
        return ComisionSucursalSchema.parse(res.data);
    },
};
